import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { forwardRef } from 'react';
import { Container } from '../Container.js';
export const IconFamilyRestroom = forwardRef((props, ref) => _jsx(Container, {
  "data-testid": "IconFamilyRestroom",
  ref: ref,
  ...props,
  children: _jsx("path", {
    d: "M720-720q-33 0-56-23t-24-57 24-56 56-24 57 24 23 56-23 57-57 23m-40 600v-280q0-40-20-72t-53-50l35-103q8-25 30-40t48-15 49 15 29 40l84 252q7 20-5 37t-33 16h-44v200q0 17-11 29t-29 11h-40q-17 0-28-11t-12-29M500-500q-25 0-42-17t-18-43 18-42 42-18 43 18 17 42-17 43-43 17M220-720q-33 0-56-23t-24-57 24-56 56-24 57 24 23 56-23 57-57 23m-80 600v-240h-20q-17 0-28-11t-12-29v-200q0-33 24-56t56-24h120q33 0 57 24t23 56v200q0 17-11 29t-29 11h-20v240q0 17-11 29t-29 11h-80q-17 0-28-11t-12-29m300 0v-120q-17 0-28-11t-12-29v-120q0-25 18-42t42-18h80q25 0 43 18t17 42v120q0 17-11 29t-29 11v120q0 17-11 29t-29 11h-40q-17 0-28-11t-12-29"
  })
}));